import React, { ComponentType, ReactElement } from 'react';
import { EditorPlugin } from '../draft-js-plugins-editor/src';
import CTA from './components/CTA';
import CTAButton, { CTAButtonProps } from './components/CTAButton';
import { defaultTheme } from './theme';
import { ENTITY_TYPE } from '../utils/types';
import { RenderCTA } from '$/components/ui/Input/CTAButton/types';

export const ButtonThemeStyles = defaultTheme;

interface ButtonPluginConfig {
  isPublish?: boolean;
  decorator?: unknown;
  onlyCustomCTA?: boolean;
  defaultText?: string;
  renderCTA?: RenderCTA;
}

const createCTAPlugin = ({
  isPublish,
  decorator,
  onlyCustomCTA,
  defaultText,
  renderCTA,
}: ButtonPluginConfig = {}): EditorPlugin & {
  CTAButton: ComponentType<CTAButtonProps>;
} => {
  let CTAComponent = CTA;

  if (typeof decorator === 'function') {
    CTAComponent = decorator(CTA);
  }

  const ThemeCTA = (props: any): ReactElement => (
    <CTAComponent
      {...props}
      onlyCustomCTA={onlyCustomCTA}
      isPublish={isPublish}
      theme={defaultTheme}
      renderCTA={renderCTA}
    />
  );

  const CTAButtonComponent = (props: CTAButtonProps): ReactElement => (
    <CTAButton {...props} defaultText={defaultText} />
  );

  return {
    blockRendererFn: (block, { getEditorState }) => {
      if (block.getType() === 'atomic') {
        const contentState = getEditorState().getCurrentContent();
        const entity = block.getEntityAt(0);
        if (!entity) return null;
        const type = contentState.getEntity(entity).getType();
        if (type === ENTITY_TYPE.BUTTON) {
          return {
            component: ThemeCTA,
            editable: false,
          };
        }
      }

      return null;
    },
    CTAButton: CTAButtonComponent,
  };
};

export default createCTAPlugin;
